import { applyMiddleware } from "redux";

import { autoRehydrate } from "redux-persist";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import * as api from "../../api";

export default () =>
  composeWithDevTools(
    applyMiddleware(
      thunk.withExtraArgument({
        api,
        get identity() {
          return window.__sdk.identity;
        }
      })
    ),
    autoRehydrate()
  );



// WEBPACK FOOTER //
// ./template/state/enhancers.js